import { Head, Link, usePage } from '@inertiajs/react';
import { BsCart4 } from 'react-icons/bs';
import { MdAdd } from 'react-icons/md';
import { CiImport } from 'react-icons/ci';
import { Fragment } from 'react';

import Product from './Product';
import FlashMessages from '../../components/FlashMessages';
import noProduct from '../../assets/no_product.png';
import useCart from '../../store/cart';

export default function Index({ products }) {
  const { current_user } = usePage().props;
  const isAuthenticated = current_user !== null;

  const cart = useCart((state) => state.cart);
  const cartCount = cart.reduce((total, item) => total + item.quantity, 0);

  return (
    <>
      <Head title='Products' />
      <div className='mx-auto md:w-2/3 w-full px-8 pt-4 relative'>
        <FlashMessages />

        <div className='flex justify-between items-center mt-4'>
          <h1 className='font-bold text-4xl'>Products</h1>
          <div className='flex justify-end gap-4 mr-2'>
            {isAuthenticated && (
              <Link
                href='/dashboard/products/new'
                className='flex items-center bg-yellow-primary hover:bg-yellow-secondary rounded-full text-black font-body font-bold py-0 px-3 shadow-lg transition duration-300 ease-in-out transform hover:-translate-y-1'
              >
                <MdAdd className='text-3xl font-bold' />
                <span className='hidden md:inline pl-2'>Add Product</span>
              </Link>
            )}
            {isAuthenticated && (
              <Link
                href='#'
                className='flex items-center bg-yellow-primary hover:bg-yellow-secondary rounded-full text-black font-body font-bold py-0 px-3 shadow-lg transition duration-300 ease-in-out transform hover:-translate-y-1'
              >
                <CiImport className='text-2xl font-bold' />
                <span className='hidden md:inline pl-2'>Import</span>
              </Link>
            )}
          </div>
        </div>

        <>
          {products.length === 0 ? (
            <div
              className='min-w-full flex flex-col items-center justify-center'
              style={{ height: 'calc(100vh - 225px)' }}
            >
              <figure className='flex flex-col items-center'>
                <img src={noProduct} alt='No Product' className='w-full h-64' />
                <figcaption className='text-center text-2xl font-medium mt-4'>
                  No Products Available
                </figcaption>
              </figure>
            </div>
          ) : (
            <div className='p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4'>
              {products.map((product) => (
                <Link
                  href={`/products/${product.id}`}
                  key={product.id}
                  className='flex justify-center'
                >
                  <Product product={product} />
                </Link>
              ))}
            </div>
          )}
        </>

        {/* Floating Cart Icon */}
        <Link
          href='/cart'
          className='fixed bottom-6 right-6 bg-yellow-primary hover:bg-yellow-secondary p-3 rounded-full shadow-lg transition duration-300 ease-in-out transform hover:-translate-y-1'
        >
          <BsCart4 size={28} className='text-black' />
          {cartCount > 0 && (
            <span className='absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full'>
              {cartCount}
            </span>
          )}
        </Link>
      </div>
    </>
  );
}
